import axiosInstance from '../api/axiosInstance';

const ENDPOINTS = {
  QR_LIST: '/DownloadQrList',
  CREATED_QR_LIST: '/CreatedQrList',
  QRKONTROL: '/QRKONTROL'
};

export const getCreatedQrListRequest = (id = '', date = '') => {
  const formData = new FormData();
  formData.append('id', id);
  formData.append('date', date);

  return axiosInstance.post(
    ENDPOINTS.CREATED_QR_LIST,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );
};

export const getCreatedQrList = async (id = '', date = '') => {
  try {
    const response = await getCreatedQrListRequest(id, date);
    if (response.data && response.data.status === 200 && Array.isArray(response.data.data)) {
      return response.data.data;
    }
    return [];
  } catch (error) {
    console.error('Created QR List fetch error:', error);
    throw error;
  }
};

export const downloadQrListRequest = (id) => {
  const formData = new FormData();
  formData.append('id', id);

  return axiosInstance.post(
    ENDPOINTS.QR_LIST,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );
};

export const downloadQrList = async (id) => {
  try {
    const response = await downloadQrListRequest(id);
    
    if (response.data && response.data.status === 200 && response.data.data) {
      const pdfUrl = response.data.data;
      
      window.open(pdfUrl, '_blank');
    }

    return response.data;
  } catch (error) {
    console.error('QR List download error:', error);
    throw error;
  }
};

export const createQrList = async (data, signal) => {
  try {
    const formData = new FormData();
    formData.append('count', data.count);
    formData.append('date', data.date);

    const response = await fetch(`${axiosInstance.defaults.baseURL}${ENDPOINTS.CREATE_QR_LIST}`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
        'accept': '*/*'
      },
      body: formData,
      signal
    });

    if (!response.ok) {
      throw new Error('QR kod oluşturma işlemi başarısız oldu.');
    }

    const result = await response.json();

    if (result.status === 200 && result.data) {
      const pdfUrl = result.data;
      
      window.open(pdfUrl, '_blank');
    }

    return result;
  } catch (error) {
    console.error('Error creating QR list:', error);
    throw error;
  }
}; 

export const checkQrCode = async (qrCode) => {
  try {
    const response = await axiosInstance.get(`${ENDPOINTS.QRKONTROL}?qrno=${qrCode}`);
    if (response.data && response.data.status === 200) {
      return response?.data?.qr;
    } else {
      throw new Error(response.data?.message || 'QR kod kontrolü başarısız oldu.');
    }
  } catch (error) {
    console.error('QR code check error:', error);
    throw error;
  }
};